var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.418,
    height: 26.484,
    viewBox: "0 0 26.418 26.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invite",
    transform: "translate(-73.096 -73.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(73.096 73.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M86.308,99.584a13.3,13.3,0,0,1-8.289-2.933,13.043,13.043,0,0,1-4.653-7.631,13.34,13.34,0,0,1,1.01-8.394,12.841,12.841,0,0,1,5.9-6A13.473,13.473,0,0,1,86.345,73.1a13.649,13.649,0,0,1,7.481,2.4.664.664,0,0,1,.217.935.652.652,0,0,1-.546.307.751.751,0,0,1-.419-.135,12.093,12.093,0,0,0-4.511-1.9,11.587,11.587,0,0,0-2.267-.224,11.934,11.934,0,0,0-11.514,9.03,11.719,11.719,0,0,0,1.706,9.531c.022.03.045.06.082.1a.224.224,0,0,0,.172.082h.03a.215.215,0,0,0,.172-.135c.045-.112.09-.232.135-.344a7.75,7.75,0,0,1,.322-.748A5.882,5.882,0,0,1,79.9,89.641,12.864,12.864,0,0,1,86.271,88.1h.112a12.833,12.833,0,0,1,6.344,1.556,5.835,5.835,0,0,1,2.6,2.618,4.765,4.765,0,0,1,.232.628c.022.067.045.142.067.209a.23.23,0,0,0,.18.15h.03a.21.21,0,0,0,.18-.1,11.539,11.539,0,0,0,1.354-2.529,11.89,11.89,0,0,0,.8-4.264.679.679,0,0,1,.613-.688h.052a.657.657,0,0,1,.658.531,3.5,3.5,0,0,1,.007.741A13.255,13.255,0,0,1,90.026,99.03,12.506,12.506,0,0,1,86.308,99.584Zm.007-10.077a12.634,12.634,0,0,0-5.2,1.032,5.689,5.689,0,0,0-2.282,1.713,2.441,2.441,0,0,0,.007,3.135,4.209,4.209,0,0,0,1.332,1.152,12.188,12.188,0,0,0,6.1,1.721h0a12.391,12.391,0,0,0,5.2-1.2,5.825,5.825,0,0,0,2.192-1.541,2.509,2.509,0,0,0,0-3.4,5.6,5.6,0,0,0-1.908-1.451,12.262,12.262,0,0,0-5.439-1.16Z",
    transform: "translate(-73.096 -73.1)",
    fill: "#6e6e6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(8.731 4.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M194.266,137.248A4.5,4.5,0,0,1,189.8,132.8a4.483,4.483,0,0,1,4.459-4.5h.015a4.474,4.474,0,1,1,.007,8.948Zm-.03-7.6h-.075a3.128,3.128,0,0,0,.09,6.254h.075a3.17,3.17,0,0,0,2.237-.98,3.069,3.069,0,0,0,.845-2.214A3.107,3.107,0,0,0,194.236,129.647Z",
    transform: "translate(-189.8 -128.3)",
    fill: "#6e6e6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(19.691 5.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M339.2,151.613a.66.66,0,0,1-.651-.7c-.007-.157,0-.322,0-.479v-.823a.22.22,0,0,0-.224-.224h-1.249c-.479,0-.771-.254-.771-.673a.678.678,0,0,1,.771-.673h1.145a.38.38,0,0,0,.1-.015.19.19,0,0,0,.052-.015.217.217,0,0,0,.172-.217v-1.339a.659.659,0,0,1,.666-.651.678.678,0,0,1,.239.045.7.7,0,0,1,.441.666c.007.277,0,.554,0,.845v.456a.22.22,0,0,0,.224.224h1.249a.825.825,0,0,1,.591.224.592.592,0,0,1,.172.456.694.694,0,0,1-.763.666h-.06c-.367,0-.748,0-1.122.007h0a.263.263,0,0,0-.142.045c-.007.007-.015.007-.03.015a.225.225,0,0,0-.127.2v1.287A.663.663,0,0,1,339.2,151.613Z",
    transform: "translate(-336.3 -145.8)",
    fill: "#6e6e6e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.259eea462b9e845f9a2035bbd638f4b2.svg";
export { ForwardRef as ReactComponent };